import {SaleEndpoints} from './endpoints';
import {
  Sale,
  saleGetListParamsURL,
  salePostParamsBody,
  salePostPayCheckoutParamsBody,
  salePostPayCodeParamsBody,
  salePostPayOtherParamsBody,
} from '../models';
import * as schemas from './schemas';
import {getToken} from '~/apps/shared/services/token';
import * as net from '~/lib/net';
import { Decimal } from 'decimal.js';


// Sales list
export async function getSaleList(saleListParams: saleGetListParamsURL = {}): Promise<Sale[]> {
  const data = await net.apiGet(SaleEndpoints.getSaleList(saleListParams), getToken());
  return schemas.SaleListSchema.load(data);
}

export async function getSaleById(saleId: string): Promise<Sale> {
  const data = await net.apiGet(SaleEndpoints.getSaleById(saleId), getToken());
  return schemas.SaleSchema.load(data);
}

export async function getSalesTotals(saleListParams: saleGetListParamsURL = {}): Promise<Sale[]> {
  const data = await net.apiGet(SaleEndpoints.getSalesTotals(saleListParams), getToken());

  const defaultData = {
    total_count_of_sales: 0,
    total_amount_of_sales: new Decimal(0),
  };

  return schemas.SalesTotalsSchema.load(data || defaultData);
}

// Sale management
export async function createSale(req: salePostParamsBody): Promise<Sale> {
  const payload = schemas.SaleRequest.save(req);

  const data = await net.apiPost(SaleEndpoints.createSale(), getToken(), payload);
  return schemas.SaleSchema.load(data);
}

export async function updateSale(saleId: string, req: salePostParamsBody): Promise<Sale> {
  const payload = schemas.SaleRequest.save(req);

  const data = await net.apiPut(SaleEndpoints.updateSale(saleId), getToken(), payload);
  return schemas.SaleSchema.load(data);
}

export async function deleteSale(saleId: string): Promise<Sale> {
  const data = await net.apiDelete(SaleEndpoints.deleteSale(saleId), getToken());
  return data;
}

export async function paySaleByCode(saleId: string, req: salePostPayCodeParamsBody): Promise<boolean> {
  const payload = schemas.SaleRequestPayCode.save(req);

  return await net.apiPost(SaleEndpoints.paySaleByCode(saleId), getToken(), payload);
}

export async function paySaleByCheckout(saleId: string, req: salePostPayCheckoutParamsBody): Promise<boolean> {
  const payload = schemas.SaleRequestPayCheckout.save(req);

  return await net.apiPost(SaleEndpoints.paySaleByCheckout(saleId), getToken(), payload);
}

export async function paySaleByOther(saleId: string, req: salePostPayOtherParamsBody): Promise<boolean> {
  const payload = schemas.SaleRequestPayOther.save(req);

  return await net.apiPost(SaleEndpoints.paySaleByOther(saleId), getToken(), payload);
}

export async function exportSales(startDate: Date, endDate: Date): Promise<Blob> {
  const resp = await net.rawRequest(
    'GET',
    SaleEndpoints.exportSaleCSV(startDate, endDate),
    getToken());

  return resp.blob();
}

export async function exportDetailSales(startDate: Date, endDate: Date): Promise<Blob> {
  const resp = await net.rawRequest(
    'GET',
    SaleEndpoints.exportDetailSalesCSV(startDate, endDate),
    getToken());

  return resp.blob();
}
